/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![KeyIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABg0lEQVR4nNWVS0oDQRCGx4WiYHTrI3oVt8FMV/VoKlVjMNkFEVyIW2/hwgN4BYkXUBR8bTxIfIEmwkgNRpIZZvKcRQp6M01/f9XffzOOM00FALltopVM4C76Fix/gJUAUM4mCgcQzyC3QnhngaxNBG4s78TgOglALiO4BIi8lxkcrATGij8W3EV/NwkeCiC39NIzgcO/iLwT0eKk4AcA5SpYaXd/97zKagxSr9dnXfQPjZUbsPwaJgLl1iCfJ3YO5aqeBY8JrHwmvgVVBJTHfuNDfLUBpKSMQqGylNi5sXw/Ajz4S87bVq02n+hv6OOgQOQLF3k/4nmbiJaTBVCuI1G7LBZp3fMqeUBp9HbLD+EZkJJ2blB+wMppakIMSjOSgHxnD5E3IlN8OY4zo3tqi/qeCh9WwKB89wXGBMJYdvssDRUJ4chXEYuehhbQ7A+cGJSToQWIaE476y/AL6lxTCv9SRjLz2lw16XNkeA9k6AcGct3epmaGI0lgBwT0cJY8KmsX4Z9lzUschlHAAAAAElFTkSuQmCC)
 */
export const KeyIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M21.41 5.41A2 2 0 1 0 18.6 2.6l-7.75 7.74a.53.53 0 0 1-.58.11 6 6 0 1 0 3.3 3.28.51.51 0 0 1 .1-.55c.19-.19.5-.19.68 0l1.25 1.24a2 2 0 1 0 2.82-2.82l-1.23-1.24a.5.5 0 0 1 0-.7l.47-.47c.2-.2.5-.2.7 0l1.24 1.23A2 2 0 1 0 22.4 7.6l-1.23-1.24a.5.5 0 0 1 0-.7l.23-.24ZM10 16a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
